// extracted by mini-css-extract-plugin
module.exports = {"container":"Applicant_container__1ta9Y","page":"Applicant_page__32Xma","section":"Applicant_section__1bGbL"};